/**
 * This file handles everything related to the notification system.
 */

document.addEventListener('click', function(e) {
    let anchor = e.target.closest('a.js-notifications-view, a.js-notifications-view-read');

    // I love nesting if statements
    if (!anchor) {
        anchor = e.target.closest('a.js-obj-mark-read');

        if (!anchor) {
            anchor = e.target.closest('a.js-obj-mark-unread');
            if (!anchor) return;
        }
    }

    // Prevent the link from doing its default behaviour
    e.preventDefault();
    e.stopPropagation();

    const notificationURL = new URL(anchor.href);
    const notificationID = notificationURL.searchParams.get('obj_id');

    if (anchor.classList.contains('js-obj-mark-read')) {
        changeNotificationReadStatus(notificationID, true);
    } else if (anchor.classList.contains('js-obj-mark-unread')) {
        changeNotificationReadStatus(notificationID, false)
    } else if (anchor.classList.contains('js-notifications-view-read')) {
        viewNotification(notificationID, true);
    } else {
        viewNotification(notificationID);
    }
});

function decreaseNotificationCount()
{
    // This could be a lot smarter, but for now this does the job.
    const notificationsNavButton = document.getElementById('c-notification-system');
    const counterPill = notificationsNavButton.getElementsByClassName('notification-count');

    if (counterPill.length) {
        let newTotal = parseInt(counterPill[0].innerHTML) - 1;
        newTotal = newTotal <= 0 ? 0 : newTotal;

        counterPill[0].setAttribute('data-count', newTotal);
        counterPill[0].innerHTML = newTotal;
    }
}

function increaseNotificationCount()
{
    // This could be a lot smarter, but for now this does the job.
    const notificationsNavButton = document.getElementById('c-notification-system');
    let counterPill = notificationsNavButton.getElementsByClassName('notification-count');
    let newCount = 1;

    if (counterPill.length) {
        newCount = parseInt(counterPill[0].innerHTML) + 1;
        counterPill[0].innerHTML = newCount;
        counterPill[0].setAttribute('data-count', newCount);
    } else {
        counterPill = document.createElement('span');
        counterPill.classList.add('notification-count');
        counterPill.innerHTML = newCount;
        counterPill.setAttribute('data-count', newCount);
        notificationsNavButton.appendChild(counterPill);
    }
}

// View notifications in a modal
function viewNotification(notificationID, isRead = false) {
    // Fetch the notification data
    fetch('/admin/notification/view?notification_id=' + encodeURIComponent(notificationID))
        .then(function(response) {
            if (!response.ok) throw new Error('Network response was not ok');
            return response.json();
        })
        .then(function(notificationData) {
            if (!isRead) decreaseNotificationCount();

            const link = notificationData?.link ?? null;

            BootstrapDialog.show({
                size: BootstrapDialog.SIZE_WIDE,
                //type: BootstrapDialog.TYPE_INFO,
                title: notificationData?.title ?? '',
                message: notificationData?.description ?? '',
                onhide: function(dialog){
                    if (isRead) return;

                    const widgets = Charcoal.Admin.manager().components.widgets;

                    Object.values(widgets).forEach(function(widget) {
                        if (widget instanceof Charcoal.Admin.Widget_Quick_Form_Table) {
                            widget.show_object_actions = true;
                            widget.reload(function (widget, response) {
                                console.log(response);
                            });
                        }
                    });
                },
                buttons: [
                    link ? {
                        label: link.label,
                        action: function (dialog) {
                            window.open(link.href);
                        }
                    } : {
                        label: 'Fermer',
                        action: function (dialog) {
                            dialog.close();
                        }
                    }
                ]
            });
        })
        .catch(function(error) {
            console.error('Fetch error:', error);
            return;
        });
}

function changeNotificationReadStatus(notificationID, isRead = true) {
    fetch('/admin/notification/' + (isRead ? 'read': 'unread'), {
        method: 'POST',
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ notification_id: notificationID }),
    })
    .then(function(response) {
        if (!response.ok) throw new Error('Network response was not ok');
        return response.json();
    })
    .then(function(notificationData) {
        if (isRead) {
            decreaseNotificationCount();
        } else {
            increaseNotificationCount();
        }

        const widgets = Charcoal.Admin.manager().components.widgets;

        Object.values(widgets).forEach(function(widget) {
            if (widget instanceof Charcoal.Admin.Widget_Quick_Form_Table) {
                widget.show_object_actions = true;
                widget.reload();
            }
        });
    })
    .catch(function(error) {
        console.error('Fetch error:', error);
        return;
    });
}
